/* Returning visitors: mark pieces added since their last visit, and count them on the homepage.
   Everything stays in the visitor's own browser. A new visit starts with a new browser session. */
(function () {
  var KEY = 'mj-last-visit', SKEY = 'mj-prev-visit', now = Date.now(), prev;
  try {
    prev = sessionStorage.getItem(SKEY);
    if (prev === null) { prev = localStorage.getItem(KEY) || ''; sessionStorage.setItem(SKEY, prev); }
    localStorage.setItem(KEY, String(now));
  } catch (e) { return; }
  prev = Number(prev);
  if (!prev || now - prev < 2 * 3600 * 1000) return;
  var since = prev / 1000;

  var st = document.createElement('style');
  st.textContent = '.mj-new-line{font-weight:600}'
    + '.mj-new-since{display:inline-flex;width:fit-content;justify-self:start;align-self:flex-start;align-items:center;gap:10px;margin:0 0 18px;padding:8px 14px;border-radius:999px;background:#003B36;color:#FFF9EA;font-size:14px;text-decoration:none}'
    + '.mj-new-since i{width:8px;height:8px;border-radius:50%;background:#C39A43;display:inline-block}';
  document.head.appendChild(st);

  function mark(scope) {
    (scope || document).querySelectorAll('product-card[data-published]:not([data-mj-new-checked])').forEach(function (card) {
      card.setAttribute('data-mj-new-checked', '');
      if (Number(card.getAttribute('data-published')) <= since) return;
      card.setAttribute('data-mj-new', '');
      var line = card.querySelector('.mj-added');
      if (!line) {
        var price = card.querySelector('price-list');
        if (!price) return;
        line = document.createElement('p');
        line.className = 'text-xs text-subdued mj-added';
        price.parentNode.insertBefore(line, price);
      }
      line.textContent = 'New since your visit';
      line.classList.add('mj-new-line');
    });
  }
  function start() {
    mark();
    var t = 0;
    new MutationObserver(function () { clearTimeout(t); t = setTimeout(mark, 120); }).observe(document.body, { childList: true, subtree: true });

    var section = document.querySelector('[id*="featured_collections"]');
    if (!section) return;
    fetch('/collections/new-arrival/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var n = (j.products || []).filter(function (p) { return Date.parse(p.published_at) / 1000 > since; }).length;
        if (!n) return;
        var day = new Date(prev).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' });
        var a = document.createElement('a');
        a.className = 'mj-new-since';
        a.href = '/collections/new-arrival';
        a.innerHTML = '<i></i><span></span>';
        a.querySelector('span').textContent = n + (n === 1 ? ' new piece' : ' new pieces') + ' since your last visit on ' + day + ' →';
        var list = section.querySelector('product-list, .product-list');
        if (list && list.parentNode) list.parentNode.insertBefore(a, list);
      })
      .catch(function () {});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
